export const GET_PLANTS = 'GET_PLANTS';
export const SET_TYPE = 'SET_TYPE';
export const SET_GEOJSON = 'SET_GEOJSON';
export const SET_BG = 'SET_BG';
export const SET_SEASON = 'SET_SEASON';
export const ADD_PLANTING = 'ADD_PLANTING';
export const UPDATE_PLANTING = 'UPDATE_PLANTING';